// Import getDocument from pdfjs

import Typography from '@mui/material/Typography';
import { useIntl } from '@mfw/components';
import Link from '@mui/material/Link';

import {
  useUnsignedPrivacyPolicy,
  useAcceptPrivacyPolicy,
} from '../../hooks/privacyPolicies';
import RouterLink from '../../components/RouterLink';
import { useAuthContext } from '../../context';
import { Dialog } from '../../components';
import './PrivacyPolicyModal.scss';
import messages from './messages';
import { onSurface } from '../../theme/onSurface';

const PrivacyPolicyModal = () => {
  const { currentUser, signOutAsync } = useAuthContext();
  const { formatMessage, locale } = useIntl();
  const { data: unsignedPrivacyPolicy } = useUnsignedPrivacyPolicy({
    language: locale,
  });
  const { mutateAsync: acceptPrivacyPolicyAsync } = useAcceptPrivacyPolicy();

  // A platform user always has access (P3): it reaches this with any tenant
  // selected, on a policy written for that tenant's customers, and Cancel signs out.
  if (
    !currentUser ||
    currentUser.isPlatformUser ||
    !unsignedPrivacyPolicy ||
    Boolean(currentUser?.settings?.privacyPolicyAccepted)
  ) {
    return null;
  }
  return (
    <Dialog
      description={
        <>
          <Typography>{formatMessage(messages.description)}</Typography>

          <Typography
            sx={{ color: onSurface.primary }}
            className="Mfw-PrivacyPolicyModal-link"
          >
            {/* `/privacyPolicy` is a TOP-LEVEL route. The relative
                `"privacyPolicy"` that used to sit here resolved correctly only
                because this modal is rendered by the layout route at `/` — any
                change to that route's path would have retargeted the link
                silently. `RouterLink.to` is typed as the route union precisely
                to catch that, and the `@ts-ignore` here was turning it off. */}
            <Link
              component={RouterLink}
              className="underline"
              to="/privacyPolicy"
              target="_blank"
            >
              {formatMessage(messages.link)}
            </Link>
          </Typography>
        </>
      }
      title={formatMessage(messages.title)}
      onConfirm={acceptPrivacyPolicyAsync}
      // Wrapped, not passed by reference: the dialog calls `onClose(event, reason)`, and
      // `signOutAsync`'s first argument now says WHY the session ended. Handing it a MUI
      // close event would be a terminal sign-out with a nonsense reason. Closing this
      // modal is a manual logout, like the OTP dialog's.
      onClose={() => signOutAsync()}
      className="w-full"
      open
    />
  );
};

export default PrivacyPolicyModal;
